import { type ReactNode } from 'react';
import DynamicDialog, { type DynamicDialogProps } from '@discover-components/ui/dynamicDialog';
import OptionList, { type Option } from './optionList';

export type ComboBoxProps = {
  options: Option[];
  placeholder: string;
  description: string;
  value?: string | null;
  setValue: (value: string | undefined) => void;
  className?: string;
  children?: ReactNode;
} & Omit<DynamicDialogProps, 'triggerLabel' | 'dialogTitle' | 'dialogDescription' | 'children'>;

export default function ComboBox({
  options,
  placeholder,
  description,
  value,
  setValue,
  className,
  children,
  triggerProps,
  ...props
}: ComboBoxProps) {
  const selectedOption = options.find(({ value: optionValue }) => optionValue === value);
  const label = selectedOption ? selectedOption.label : placeholder;

  return (
    <DynamicDialog
      triggerLabel={label}
      triggerProps={{
        children,
        className,
        ...triggerProps,
      }}
      dialogTitle={placeholder}
      dialogDescription={description}
      {...props}>
      {({ setOpen }) => (
        <OptionList
          options={options}
          setOpen={setOpen}
          value={value}
          setValue={setValue}
          placeholder={placeholder}
        />
      )}
    </DynamicDialog>
  );
}
